var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ContentLayout", {
    attrs: {
      title: _vm.$t("label_essweb_RosterForm_form_newTitle"),
      widthClass: "max-1000",
      initData: _vm.rosterFormData,
      backgroundClass: "white",
      checkData: ["roster_form_name", "roster_property_group_uuid", "remarks"],
    },
    on: {
      change: function (changed) {
        return (_vm.isChanged = changed)
      },
    },
    scopedSlots: _vm._u([
      {
        key: "page-main",
        fn: function () {
          return [
            _c(
              "v-container",
              { staticClass: "pa-0", attrs: { fluid: "" } },
              [
                _c(
                  "v-form",
                  { ref: "form", attrs: { "lazy-validation": "" } },
                  [
                    _c(
                      "v-row",
                      [
                        _c(
                          "v-col",
                          {
                            attrs: {
                              xs: "12",
                              sm: "6",
                              md: "6",
                              lg: "6",
                              cols: "12",
                            },
                          },
                          [
                            _c("inputTextFiledMultiLang", {
                              attrs: {
                                maxlength: "200",
                                bindData: _vm.rosterFormData.roster_form_name,
                                label: _vm.$t(
                                  "label_essweb_RosterForm_form_rosterFormNameLabel"
                                ),
                                rules: _vm.$GetRules(
                                  ["_Require_Rules"],
                                  [null]
                                ),
                              },
                              on: {
                                change: function (valueArr) {
                                  _vm.rosterFormData.roster_form_name = valueArr
                                },
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "v-col",
                          {
                            attrs: {
                              xs: "12",
                              sm: "6",
                              md: "6",
                              lg: "6",
                              cols: "12",
                            },
                          },
                          [
                            _c("AutoComplete", {
                              attrs: {
                                isRequired: "",
                                label:
                                  "label_essweb_RosterForm_form_rosterFormGroupLabel",
                                items: _vm.RosterPropertyGroup,
                                "item-text": "roster_property_group_name",
                                "item-value": "uuid",
                                rules: _vm.$GetRules(
                                  ["_Require_Rules"],
                                  [null]
                                ),
                              },
                              model: {
                                value:
                                  _vm.rosterFormData.roster_property_group_uuid,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.rosterFormData,
                                    "roster_property_group_uuid",
                                    $$v
                                  )
                                },
                                expression:
                                  "rosterFormData.roster_property_group_uuid",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "v-col",
                          {
                            attrs: {
                              xs: "12",
                              sm: "12",
                              md: "12",
                              lg: "12",
                              cols: "12",
                            },
                          },
                          [
                            _c("inputTextFiledMultiLang", {
                              attrs: {
                                maxlength: "500",
                                bindData:
                                  _vm.rosterFormData.roster_form_description,
                                label: _vm.$t(
                                  "label_essweb_RosterForm_form_rosterFormDescriptionLabel"
                                ),
                              },
                              on: {
                                change: function (valueArr) {
                                  _vm.rosterFormData.roster_form_description =
                                    valueArr
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c("Tabler", {
                  attrs: {
                    headers: _vm.headers,
                    items: _vm.desserts,
                    showSelect: _vm.showSelect,
                    border: "",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "item.shift_type",
                      fn: function (ref) {
                        var item = ref.item
                        return _vm._l(
                          item.ess_att_shift_type,
                          function (it, index) {
                            return _c(
                              "span",
                              {
                                key: index,
                                staticClass: "text--primary table-title",
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$getCommonLangValue(
                                        it.shift_type_name
                                      )
                                    ) +
                                    " "
                                ),
                                index < item.ess_att_shift_type.length - 1
                                  ? _c("span", [_vm._v(",")])
                                  : _vm._e(),
                              ]
                            )
                          }
                        )
                      },
                    },
                    {
                      key: "item.shift_name",
                      fn: function (ref) {
                        var item = ref.item
                        return [
                          _c(
                            "div",
                            { staticClass: "text--primary table-title" },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$getCommonLangValue(item.shift_name)
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                    {
                      key: "item.time",
                      fn: function (ref) {
                        var item = ref.item
                        return [
                          _c(
                            "div",
                            { staticClass: "text--primary table-title" },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$timeMachine(item.start_utc_time) +
                                      " - " +
                                      _vm.$timeMachine(item.end_utc_time)
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                    {
                      key: "item.action",
                      fn: function (ref) {
                        var item = ref.item
                        return [
                          _c(
                            "v-btn",
                            {
                              attrs: { icon: "" },
                              on: {
                                click: function ($event) {
                                  return _vm.toDeleteShift(item.uuid)
                                },
                              },
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "material-icons-round" },
                                [_vm._v("delete")]
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c(
                  "v-container",
                  { staticClass: "pa-0", attrs: { fluid: "" } },
                  [
                    _c(
                      "v-btn",
                      {
                        staticClass: "my-2 text-capitalize",
                        attrs: { text: "", small: "", color: "primary" },
                        on: {
                          click: function ($event) {
                            _vm.showNewShift = true
                          },
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t(
                                "label_essweb_RosterForm_form_newShiftBtnLabel"
                              )
                            ) +
                            " "
                        ),
                        _c("span", { staticClass: "material-icons-round" }, [
                          _vm._v("add"),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "page-actions",
        fn: function () {
          return [
            _c("CardActions", {
              attrs: { newBtn: "" },
              on: {
                new: _vm.toNew,
                cancel: function ($event) {
                  return _vm.$toBack(_vm.isChanged)
                },
              },
            }),
          ]
        },
        proxy: true,
      },
      {
        key: "tools-main",
        fn: function () {
          return [
            _c("newShiftDialog", {
              attrs: { show: _vm.showNewShift, curUuid: _vm.curUuid },
              on: {
                onNew: _vm.onNewShift,
                close: function ($event) {
                  _vm.showNewShift = false
                },
              },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }